import { Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectorRef,
  ChangeDetectionStrategy, inject, DestroyRef } from '@angular/core';
import { AppService } from '../../../app.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { Form5471TextinfoService } from '../form5471-textinfo/form5471-textinfo.service';
import * as _ from 'lodash-es';
import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-form5471-schedule-i',
    templateUrl: './form5471-schedule-i.component.html',
    styleUrls: ['./form5471-schedule-i.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class Form5471ScheduleIComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  modalTitle = "Schedule I Summary of Shareholder's Income Form Foreign Corporation";

  // Component properties
  irsF5471ScheduleIData: any[] = [];
  attribData: any = {};
  radioBlk: string = '';
  radioUnblk: string = '';
  radiodisp: string = '';
  boyEd: string = '';
  eoyEd: string = '';
  boyAgg: string = '';
  eoyAgg: string = '';
  totDed: string = '';
  tax_year_flag: boolean = false;

  showFormLoader = true;
  crudLoading = false;
  minimise = false;
  modal_name: string | null = null;

  rowData: any = {};
  filterParams: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};

  private isInitialized = false;
  private isLoading = false;

  constructor(
    private form5471Service: Form5471TextinfoService,
    private gtwSnackbarService: GtwSnackbarService,
    private cdr: ChangeDetectorRef,
    private appService: AppService,
    private globalServiceProvider: GlobalService,
    private workspaceService: WorkspaceService
  ) {}

  ngOnInit(): void {
    this.initializeFromServices();
    this.tryInit();
  }

  private initializeFromServices(): void {
    const activeScreen = this.workspaceService.workspaceFactory?.activeScreen || {};
    const activeScreenData = activeScreen?.data || {};
    const selectedRowData = activeScreenData?.selected?.rowData;
    const directRowData = activeScreenData?.rowData;
    const fallbackRowData = activeScreenData && !activeScreenData.selected ? activeScreenData : {};

    const rowData = this.extractObject(selectedRowData || directRowData || fallbackRowData);
    if (Object.keys(rowData).length > 0) {
      this.rowData = rowData;
    }

    const filterParams = this.extractObject(
      activeScreen?.filters?.getFilterParams?.() ||
      activeScreen?.filters?.getFilterParamsFromCache?.() ||
      {}
    );
    if (Object.keys(filterParams).length > 0) {
      this.filterParams = filterParams;
    }

    const urls = this.extractObject(this.globalServiceProvider.GENERAL_CONFIG || {});
    if (Object.keys(urls).length > 0) {
      this.GENERAL_CONFIG = { ...this.GENERAL_CONFIG, ...urls };
    }

    const globalParams = this.extractObject(this.globalServiceProvider.global?.globalParams || {});
    if (Object.keys(globalParams).length > 0) {
      this.globalService = { ...globalParams };
    } else {
      this.globalService = {
        ...(this.globalService || {}),
        sso_id: this.appService.USER_SETTINGS?.user?.sso_id || ''
      };
    }
  }

  private extractObject(value: any): Record<string, any> {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      return {};
    }
    return value;
  }

  private tryInit(): void {
    if (this.isInitialized || this.isLoading) return;

    this.initializeFromServices();

    const taxYear = this.getCorrectTaxYear();
    this.tax_year_flag = taxYear === '2019';

    if (
      this.rowData &&
      Object.keys(this.rowData).length > 0 &&
      this.GENERAL_CONFIG &&
      (this.GENERAL_CONFIG.base_url || this.GENERAL_CONFIG.api_url)
    ) {
      this.isLoading = true;
      this.modal_name = 'form5471-schedule-i';
      this.initLoadData();
    }
  }

  private getBaseUrl(): string {
    return this.GENERAL_CONFIG.base_url || this.GENERAL_CONFIG.api_url || '';
  }

  private getCorrectTaxYear(): string {
    return (
      this.filterParams?.tax_year ||
      this.rowData.TAX_YEAR ||
      this.globalService?.tax_year ||
      ''
    );
  }

  private getCorrectScenario(): any {
    if (this.filterParams?.scenario) return this.filterParams.scenario;
    if (this.globalService?.checkLockedbj) {
      try {
        const checkLocked = safeJsonInput<any>(this.globalService.checkLockedbj, null, 'form5471-schedule-i.parse1');
        if (Array.isArray(checkLocked) && checkLocked.length > 0 && checkLocked[0].scenario_key) {
          return checkLocked[0].scenario_key;
        }
      } catch (e) {}
    }
    return this.globalService?.scenario;
  }

  private getJcdKey(): any {
    const jcd = this.globalService?.jcd_key;
    return jcd === '' || jcd === undefined ? 250 : jcd;
  }

  initLoadData(): void {
    this.showFormLoader = true;
    this.cdr.detectChanges();

    const params = {
      action_code: 'pru0jb',
      irs_form_no: 'F5471',
      combination_key: this.rowData.HO_COMBINATION_KEY,
      tax_year: this.getCorrectTaxYear(),
      scenario: this.getCorrectScenario(),
      jcd_key: this.getJcdKey()
    };

    this.form5471Service
      .getScheduleGData(this.getBaseUrl(), params, this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (data: any) => {
          if (data.callSuccess === '1') {
            const jsonObject = data.jsonObject || [];
            this.processScheduleIData(jsonObject);
          } else {
            if (data.errorMessage) {
              this.gtwSnackbarService.openSnackBar(data.errorMessage, 'gtw-snackbar--red');
            } else {
              this.gtwSnackbarService.openSnackBar(
                'An error occurred. If you continue to experience this issue please visit the help page to contact support.',
                'gtw-snackbar--red'
              );
            }
          }
          this.showFormLoader = false;
          this.isLoading = false;
          this.isInitialized = true;
          this.cdr.detectChanges();
        },
        (error: any) => {
          console.error('Error loading Schedule I data:', error);
          this.showFormLoader = false;
          this.isLoading = false;
          this.gtwSnackbarService.openSnackBar(
            'An error occurred loading Schedule I data.',
            'gtw-snackbar--red'
          );
          this.cdr.detectChanges();
        }
      );
  }

  processScheduleIData(data: any[]): void {
    this.irsF5471ScheduleIData = [];
    this.attribData = {};

    if (!data || data.length < 2) return;

    for (let i = 1; i < data.length; i++) {
      const row = data[i];
      const objectId = row.object_id || '';
      const attribValue = row.attrib_value || '';
      const parts = attribValue.split('~');
      const attribName = parts[0];
      const attribValueStr = row.VALUE === '0' ? '' : (row.VALUE ?? '');
      const objParts = objectId.split('~');

      const processed = {
        tax_year: objParts[0],
        trans_type_key: objParts[1],
        attrib_name: attribName,
        attrib_desc: parts[3],
        line_attrib_key: parts[1],
        trans_details_key: objParts[3],
        occurrence: objParts[4],
        VALUE: row.VALUE,
        form_key: objParts[6],
        i: row,
        line_no: row.line_no
      };

      this.irsF5471ScheduleIData.push(processed);

      if (attribName === '5471_I_UNBLK_Y' && attribValueStr === 'Y') {
        this.radioUnblk = 'Y';
        this.attribData['5471_I_UNBLK_Y'] = 'Y';
        this.attribData['5471_I_UNBLK_N'] = null;
      } else if (attribName === '5471_I_UNBLK_N' && attribValueStr === 'N') {
        this.radioUnblk = 'N';
        this.attribData['5471_I_UNBLK_Y'] = null;
        this.attribData['5471_I_UNBLK_N'] = 'N';
      } else if (attribName === '5471_I_UNBLK_Y' && (attribValueStr === undefined || attribValueStr === '')) {
        this.radioUnblk = 'N';
        this.attribData['5471_I_UNBLK_Y'] = null;
        this.attribData['5471_I_UNBLK_N'] = 'N';
      } else if (attribName === '5471_I_BLK_Y' && attribValueStr === 'Y') {
        this.radioBlk = 'Y';
        this.attribData['5471_I_BLK_Y'] = 'Y';
        this.attribData['5471_I_BLK_N'] = null;
      } else if (attribName === '5471_I_BLK_N' && attribValueStr === 'N') {
        this.radioBlk = 'N';
        this.attribData['5471_I_BLK_Y'] = null;
        this.attribData['5471_I_BLK_N'] = 'N';
      } else if (attribName === '5471_I_BLK_Y' && (attribValueStr === undefined || attribValueStr === '')) {
        this.radioBlk = 'N';
        this.attribData['5471_I_BLK_Y'] = null;
        this.attribData['5471_I_BLK_N'] = 'N';
      } else if (attribName === '5471_I_ED_ACCOUNT_IND_Y' && attribValueStr === 'Y') {
        this.radiodisp = 'Y';
        this.attribData['5471_I_ED_ACCOUNT_IND_Y'] = 'Y';
        this.attribData['5471_I_ED_ACCOUNT_IND_N'] = null;
      } else if (attribName === '5471_I_ED_ACCOUNT_IND_N' && attribValueStr === 'N') {
        this.radiodisp = 'N';
        this.attribData['5471_I_ED_ACCOUNT_IND_Y'] = null;
        this.attribData['5471_I_ED_ACCOUNT_IND_N'] = 'N';
      } else if (attribName === '5471_I_ED_ACCOUNT_IND_Y' && (attribValueStr === undefined || attribValueStr === '')) {
        this.radiodisp = 'N';
        this.attribData['5471_I_ED_ACCOUNT_IND_Y'] = null;
        this.attribData['5471_I_ED_ACCOUNT_IND_N'] = 'N';
      } else if (attribName === '5471_I_BOY_ED_ACCOUNT_BAL_AMT') {
        this.boyEd = this.radiodisp === 'N' ? '' : attribValueStr;
      } else if (attribName === '5471_I_EOY_ED_ACCOUNT_BAL_AMT') {
        this.eoyEd = this.radiodisp === 'N' ? '' : attribValueStr;
      } else if (attribName === '5471_I_BOY_AGGRGT_ED_ACCOUNT_BAL_AMT') {
        this.boyAgg = attribValueStr;
      } else if (attribName === '5471_I_EOY_AGGRGT_ED_ACCOUNT_BAL_AMT') {
        this.eoyAgg = attribValueStr;
      } else if (attribName === '5471_I_TOT_HYBRID_DEDUCTION_ACCT_AMT') {
        this.totDed = attribValueStr;
      } else {
        this.attribData[attribName] = attribValueStr;
      }
    }
  }

  checkingForValidationForI(value: string): void {
    if (value === 'N') {
      this.boyEd = '';
      this.eoyEd = '';
    }
    this.cdr.detectChanges();
  }

  findIndex(data: any[], attribName: string, value: any): any {
    const findData = data.find((x: any) => x.attrib_name === attribName);
    if (findData) {
      findData.VALUE = value;
      return findData;
    }
    return null;
  }

  saveScheduleIForm(): void {
    if (this.crudLoading) {
      this.gtwSnackbarService.openSnackBar('Please wait while we save this request', 'gtw-snackbar--red');
      return;
    }

    this.crudLoading = true;
    this.cdr.detectChanges();

    const scheduleSettings = [
      {
        tax_year: this.getCorrectTaxYear(),
        scenario: this.getCorrectScenario(),
        jcd_key: this.getJcdKey()
      }
    ];

    if (this.radioUnblk === 'Y') {
      this.attribData['5471_I_UNBLK_Y'] = this.radioUnblk;
      this.attribData['5471_I_UNBLK_N'] = null;
    } else {
      this.attribData['5471_I_UNBLK_N'] = this.radioUnblk || null;
      this.attribData['5471_I_UNBLK_Y'] = null;
    }

    if (this.radioBlk === 'Y') {
      this.attribData['5471_I_BLK_Y'] = this.radioBlk;
      this.attribData['5471_I_BLK_N'] = null;
    } else {
      this.attribData['5471_I_BLK_N'] = this.radioBlk || null;
      this.attribData['5471_I_BLK_Y'] = null;
    }

    if (this.radiodisp === 'Y') {
      this.attribData['5471_I_ED_ACCOUNT_IND_Y'] = this.radiodisp;
      this.attribData['5471_I_ED_ACCOUNT_IND_N'] = null;
    } else {
      this.attribData['5471_I_ED_ACCOUNT_IND_N'] = this.radiodisp || null;
      this.attribData['5471_I_ED_ACCOUNT_IND_Y'] = null;
    }

    this.attribData['5471_I_BOY_ED_ACCOUNT_BAL_AMT'] = this.boyEd || null;
    this.attribData['5471_I_EOY_ED_ACCOUNT_BAL_AMT'] = this.eoyEd || null;
    this.attribData['5471_I_BOY_AGGRGT_ED_ACCOUNT_BAL_AMT'] = this.boyAgg || null;
    this.attribData['5471_I_EOY_AGGRGT_ED_ACCOUNT_BAL_AMT'] = this.eoyAgg || null;
    this.attribData['5471_I_TOT_HYBRID_DEDUCTION_ACCT_AMT'] = this.totDed || null;

    const editRow: any[] = [];
    const taxYear = this.getCorrectTaxYear();

    if (this.irsF5471ScheduleIData.length > 0) {
      const saveSchedule: any[] = [];
      const attrKeys: string[] =
        taxYear > '2019'
          ? [
              '5471_I_UNBLK_Y',
              '5471_I_UNBLK_N',
              '5471_I_BLK_Y',
              '5471_I_BLK_N',
              '5471_I_ED_ACCOUNT_IND_Y',
              '5471_I_ED_ACCOUNT_IND_N',
              '5471_I_BOY_ED_ACCOUNT_BAL_AMT',
              '5471_I_EOY_ED_ACCOUNT_BAL_AMT',
              '5471_I_BOY_AGGRGT_ED_ACCOUNT_BAL_AMT',
              '5471_I_EOY_AGGRGT_ED_ACCOUNT_BAL_AMT',
              '5471_I_TOT_HYBRID_DEDUCTION_ACCT_AMT'
            ]
          : ['5471_I_UNBLK_Y', '5471_I_UNBLK_N', '5471_I_BLK_Y', '5471_I_BLK_N'];

      for (const key of attrKeys) {
        const found = this.findIndex(
          this.irsF5471ScheduleIData,
          key,
          this.attribData[key]
        );
        if (found) {
          saveSchedule.push(found);
        }
      }

      for (const item of saveSchedule) {
        const saveObject = [
          {
            tax_year: this.getCorrectTaxYear(),
            trans_type_key: item.trans_type_key,
            combination_key: this.rowData.HO_COMBINATION_KEY,
            group_obj_key: this.rowData.GROUP_OBJ_KEY,
            form_key: item.form_key,
            line_no: item.i?.line_no,
            occurence: item.occurrence === '0' ? null : item.occurrence,
            line_attrib_key: item.line_attrib_key,
            Attribute_Name: item.attrib_name,
            Attribute_Value:
              this.attribData[item.attrib_name] === '' ? '' : this.attribData[item.attrib_name],
            trans_dtls_key: item.trans_details_key === '0' ? null : item.trans_details_key,
            trans_status: 'A'
          }
        ];
        editRow.push(saveObject);
      }
    }

    const scheduleDetails = { addrows: [], editrows: editRow, removerows: [] };

    this.form5471Service
      .saveForm5471ScheduleI(
        this.getBaseUrl(),
        scheduleSettings,
        scheduleDetails,
        this.globalService,
        this.filterParams
      ).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (result: any) => {
          this.crudLoading = false;
          if (result.errorMessage && result.errorMessage !== 'null') {
            this.gtwSnackbarService.openSnackBar(result.errorMessage, 'gtw-snackbar--red');
          } else {
            this.gtwSnackbarService.openSnackBar(
              'Schedule I details successfully saved',
              'gtw-snackbar--green'
            );
            this.requestGridUpdate.emit('refresh');
          }
          this.cdr.detectChanges();
        },
        (error: any) => {
          this.crudLoading = false;
          this.gtwSnackbarService.openSnackBar(
            'Error saving Schedule I. Please try again.',
            'gtw-snackbar--red'
          );
          this.cdr.detectChanges();
        }
      );
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }
}
